// Design tokens and theme utilities - refined and more sophisticated
// Spacing scale - more refined
export const spacing = {
  xs: 'px-2 py-1',
  sm: 'px-3 py-2',
  md: 'px-4 py-2.5',
  lg: 'px-6 py-3.5',
  xl: 'px-8 py-5',
}
// Typography scale - more hierarchy
export const typography = {
  h1: 'text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight',
  h2: 'text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight',
  h3: 'text-xl md:text-2xl font-semibold tracking-tight',
  h4: 'text-lg md:text-xl font-semibold',
  body: 'text-sm md:text-base leading-relaxed',
  small: 'text-xs md:text-sm',
  caption: 'text-xs opacity-70',
}
// Rounded corners - more variety
export const radius = {
  sm: 'rounded-md',
  md: 'rounded-lg',
  lg: 'rounded-xl',
  xl: 'rounded-2xl',
  '2xl': 'rounded-3xl',
  full: 'rounded-full',
}
// Shadow variations - more subtle
export const shadow = {
  sm: 'shadow-sm',
  md: 'shadow-md',
  lg: 'shadow-lg shadow-black/5',
  xl: 'shadow-xl shadow-black/10',
  '2xl': 'shadow-2xl shadow-black/15',
  inner: 'shadow-inner',
  none: 'shadow-none',
}
// Animation presets
export const animation = {
  fadeIn: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  },
  slideUp: {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 20 },
  },
  slideDown: {
    initial: { opacity: 0, y: -20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
  },
  slideLeft: {
    initial: { opacity: 0, x: 20 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 20 },
  },
  slideRight: {
    initial: { opacity: 0, x: -20 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -20 },
  },
  scale: {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.95 },
  },
}
// Transition presets - more refined
export const transition = {
  fast: { duration: 0.15, ease: [0.4, 0, 0.2, 1] },
  medium: { duration: 0.25, ease: [0.4, 0, 0.2, 1] },
  slow: { duration: 0.4, ease: [0.4, 0, 0.2, 1] },
  bounce: { type: 'spring', damping: 15, stiffness: 150 },
  gentle: { type: 'spring', damping: 25, stiffness: 120 },
}
// Color themes - more refined
export const colorThemes = {
  dark: {
    bg: 'bg-slate-950',
    card: 'bg-slate-900/90',
    border: 'border-slate-800/50',
    text: 'text-slate-100',
    textSecondary: 'text-slate-400',
    accent: 'text-violet-400',
    hover: 'hover:bg-slate-800/50',
  },
  light: {
    bg: 'bg-slate-50',
    card: 'bg-white/90',
    border: 'border-slate-200/80',
    text: 'text-slate-900',
    textSecondary: 'text-slate-600',
    accent: 'text-indigo-600',
    hover: 'hover:bg-slate-100/50',
  },
  neon: {
    bg: 'bg-slate-950',
    card: 'bg-slate-900/90',
    border: 'border-teal-900/30',
    text: 'text-teal-50',
    textSecondary: 'text-teal-300/70',
    accent: 'text-teal-400',
    hover: 'hover:bg-teal-950/30',
  },
}
